// AI 生成 + 手动修改
/**
 * 获取详细的网络状态信息
 */
export function getNetworkStatus(): {
    isOnline: boolean;
    connectionType: string;
    effectiveType: string;
    downlink: number;
    rtt: number;
    saveData: boolean;
} {
    const networkInfo = {
        isOnline: navigator?.onLine,
        connectionType: 'unknown',
        effectiveType: 'unknown',
        downlink: 0,
        rtt: 0,
        saveData: false,
    };

    if (typeof navigator === 'undefined') {
        return networkInfo;
    }

    // 检查 Network Information API 支持
    if ('connection' in navigator) {
        const connection = (navigator as any).connection;
        if (connection) {
            networkInfo.connectionType = connection.type || 'unknown';
            networkInfo.effectiveType = connection.effectiveType || 'unknown';
            networkInfo.downlink = connection.downlink || 0;
            networkInfo.rtt = connection.rtt || 0;
            networkInfo.saveData = connection.saveData || false;
        }
    }

    return networkInfo;
}

/**
 * 检测是否为慢速网络
 */
export function isSlowNetwork(): boolean {
    const networkStatus = getNetworkStatus();

    // 检查是否为慢速网络
    const slowNetworkTypes = ['slow-2g', '2g', '3g'];
    const isSlowType = slowNetworkTypes.includes(networkStatus.effectiveType);

    // 检查下行速度
    const isSlowSpeed = (networkStatus.downlink || 0) > 0 && (networkStatus.downlink || 0) < 1; // 小于 1 Mbps

    // 检查 RTT
    const isHighLatency = (networkStatus.rtt || 0) > 1000; // 大于 1 秒

    return isSlowType || isSlowSpeed || isHighLatency;
}
